import React, { useState, useEffect } from "react";
import "./MaintenancePage.css";

const brands = [
  { href: "https://99kim.wiki", logo: "/images/logo/ic-logo-99kim.svg",  activeLogo: "/images/logo/ic-99kim-color.svg",  alt: "99kim",  key: "b99kim",  logoHeight: 34 },
  { href: "https://kim66.pages.dev", logo: "/images/logo/ic-logo-kim66.svg", activeLogo: "/images/logo/ic-logo-kim66.svg", alt: "kim66", key: "bkim66", logoHeight: 28 },
  { href: "https://kim88.ink",  logo: "/images/logo/ic-kim88-color.svg", activeLogo: "/images/logo/ic-kim88-color.svg",  alt: "kim88",  key: "bkim88",  logoHeight: 26 },
  { href: "https://kim99.ooo",  logo: "/images/logo/ic-kim99-color.svg", activeLogo: "/images/logo/ic-kim99-color.svg",  alt: "kim99",  key: "bkim99",  logoHeight: 26 },
];

function MaintenancePage() {
  const [activeIndex, setActiveIndex] = useState(2);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex(prev => (prev + 1) % brands.length);
    }, 2500);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="maintenance-wrapper">
      <div className="bg-circles">
        <div className="circle circle-1" />
        <div className="circle circle-2" />
        <div className="circle circle-3" />
      </div>

      <div className="maintenance-card">
        {/* Clouds */}
        <div className="clouds">
          <svg className="cloud cloud-left" viewBox="0 0 80 50" fill="none">
            <ellipse cx="40" cy="30" rx="35" ry="18" fill="#d9d9d9" />
            <ellipse cx="25" cy="28" rx="18" ry="14" fill="#d9d9d9" />
            <ellipse cx="55" cy="26" rx="20" ry="15" fill="#d9d9d9" />
          </svg>
          <svg className="cloud cloud-right" viewBox="0 0 80 50" fill="none">
            <ellipse cx="40" cy="30" rx="35" ry="18" fill="#d9d9d9" />
            <ellipse cx="25" cy="28" rx="18" ry="14" fill="#d9d9d9" />
            <ellipse cx="55" cy="26" rx="20" ry="15" fill="#d9d9d9" />
          </svg>
        </div>

        {/* Main illustration */}
        <div className="illustration">
          {/* Left barrier */}
          <div className="barrier barrier-left">
            <svg viewBox="0 0 70 90" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="5" y="20" width="60" height="14" rx="3" fill="#F5A623" />
              <rect x="5" y="20" width="60" height="14" rx="3" fill="none" stroke="#333" strokeWidth="2.5" />
              <rect x="5" y="20" width="20" height="14" fill="#F5A623" />
              <rect x="25" y="20" width="20" height="14" fill="white" />
              <rect x="45" y="20" width="20" height="14" fill="#F5A623" />
              <rect x="5" y="20" width="60" height="14" rx="3" fill="none" stroke="#333" strokeWidth="2.5" />
              <rect x="5" y="38" width="60" height="14" rx="3" fill="#F5A623" />
              <rect x="5" y="38" width="20" height="14" fill="white" />
              <rect x="25" y="38" width="20" height="14" fill="#F5A623" />
              <rect x="45" y="38" width="20" height="14" fill="white" />
              <rect x="5" y="38" width="60" height="14" rx="3" fill="none" stroke="#333" strokeWidth="2.5" />
              <rect x="20" y="54" width="5" height="26" rx="2" fill="#555" />
              <rect x="45" y="54" width="5" height="26" rx="2" fill="#555" />
              <rect x="10" y="78" width="50" height="8" rx="4" fill="#555" />
            </svg>
          </div>

          {/* Monitor */}
          <div className="monitor-wrap">
            <svg viewBox="0 0 220 200" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="10" y="10" width="200" height="140" rx="12" fill="#f5f0e8" stroke="#333" strokeWidth="4" />
              <rect x="22" y="22" width="176" height="116" rx="6" fill="#ebe5d8" stroke="#333" strokeWidth="2.5" />
              <g transform="translate(60, 18)">
                <ellipse cx="50" cy="55" rx="42" ry="10" fill="#F5A623" stroke="#333" strokeWidth="2.5" />
                <path d="M8 55 Q8 20 50 15 Q92 20 92 55 Z" fill="#F5A623" stroke="#333" strokeWidth="2.5" />
                <rect x="30" y="32" width="40" height="8" rx="4" fill="#e09010" stroke="#333" strokeWidth="1.5" />
              </g>
              <g transform="translate(48, 75)">
                <path d="M20 10 Q10 0 5 8 Q0 16 10 20 L55 65 Q60 70 68 65 Q76 60 70 52 L25 8 Q22 5 20 10Z"
                  fill="#aaa" stroke="#333" strokeWidth="2.5" strokeLinejoin="round" />
                <circle cx="12" cy="14" r="9" fill="#ccc" stroke="#333" strokeWidth="2.5" />
                <circle cx="64" cy="57" r="9" fill="#ccc" stroke="#333" strokeWidth="2.5" />
              </g>
              <rect x="100" y="150" width="20" height="22" rx="3" fill="#555" stroke="#333" strokeWidth="2.5" />
              <rect x="75" y="170" width="70" height="12" rx="6" fill="#555" stroke="#333" strokeWidth="2.5" />
            </svg>
          </div>

          {/* Right barrier */}
          <div className="barrier barrier-right">
            <svg viewBox="0 0 70 90" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="5" y="20" width="60" height="14" rx="3" fill="#F5A623" />
              <rect x="5" y="20" width="20" height="14" fill="white" />
              <rect x="25" y="20" width="20" height="14" fill="#F5A623" />
              <rect x="45" y="20" width="20" height="14" fill="white" />
              <rect x="5" y="20" width="60" height="14" rx="3" fill="none" stroke="#333" strokeWidth="2.5" />
              <rect x="5" y="38" width="60" height="14" rx="3" fill="#F5A623" />
              <rect x="5" y="38" width="20" height="14" fill="#F5A623" />
              <rect x="25" y="38" width="20" height="14" fill="white" />
              <rect x="45" y="38" width="20" height="14" fill="#F5A623" />
              <rect x="5" y="38" width="60" height="14" rx="3" fill="none" stroke="#333" strokeWidth="2.5" />
              <rect x="20" y="54" width="5" height="26" rx="2" fill="#555" />
              <rect x="45" y="54" width="5" height="26" rx="2" fill="#555" />
              <rect x="10" y="78" width="50" height="8" rx="4" fill="#555" />
            </svg>
          </div>

          {/* Gear icons */}
          <div className="gear gear-top-right">
            <svg viewBox="0 0 40 40" fill="none">
              <path d="M17 2h6l1 4a10 10 0 0 1 2.8 1.6l4-1 3 5.2-3 2.8a10 10 0 0 1 0 3.2l3 2.8-3 5.2-4-1A10 10 0 0 1 23 34l-1 4h-6l-1-4a10 10 0 0 1-2.8-1.6l-4 1-3-5.2 3-2.8a10 10 0 0 1 0-3.2l-3-2.8 3-5.2 4 1A10 10 0 0 1 16 6l1-4z"
                fill="#F5A623" stroke="#333" strokeWidth="1.5" />
              <circle cx="20" cy="20" r="5" fill="#ebe5d8" stroke="#333" strokeWidth="1.5" />
            </svg>
          </div>
          <div className="gear gear-bottom-left">
            <svg viewBox="0 0 30 30" fill="none">
              <path d="M13 2h4l.7 2.8a7 7 0 0 1 2 1.1l2.8-.7 2 3.5-2.1 1.9a7 7 0 0 1 0 2.2l2.1 1.9-2 3.5-2.8-.7a7 7 0 0 1-2 1.1L17 22h-4l-.7-2.8a7 7 0 0 1-2-1.1l-2.8.7-2-3.5 2.1-1.9a7 7 0 0 1 0-2.2L5.5 9.3l2-3.5 2.8.7a7 7 0 0 1 2-1.1L13 2z"
                fill="#F5A623" stroke="#333" strokeWidth="1.5" />
              <circle cx="15" cy="12" r="4" fill="#ebe5d8" stroke="#333" strokeWidth="1.5" />
            </svg>
          </div>

          {/* Dots */}
          <div className="dot dot-1" />
          <div className="dot dot-2" />
          <div className="dot dot-3" />
        </div>

        {/* Text */}
        <h1 className="title">ĐANG BẢO TRÌ</h1>
        <p className="subtitle">
          Trang web hiện đang được bảo trì định kỳ.<br />Chúng tôi sẽ sớm quay lại, xin vui lòng chờ!
        </p>

        {/* Brand logos */}
        <div className="brand-bar">
          <div className="brand-logos">
            {brands.map((brand, i) => {
              const isActive = i === activeIndex;
              return (
                <a
                  key={brand.alt}
                  href={brand.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`brand-logo-link ${brand.key}${isActive ? " is-active" : ""}`}
                >
                  <img
                    src={isActive ? brand.activeLogo : brand.logo}
                    alt={brand.alt}
                    className="brand-logo-img"
                    style={{ height: brand.logoHeight }}
                  />
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MaintenancePage;
